@if (disabled()) {
  <ng-container *ngTemplateOutlet="content"></ng-container>
} @else {
  <div class="container" matTooltip="Coming soon">
    <ng-container *ngTemplateOutlet="content"></ng-container>
    @if (preventEvents()) {
      <div class="overlay"></div>
    }
  </div>
}

<ng-template #content>
  <ng-content></ng-content>
</ng-template>
